module.exports = __webpack_public_path__ + "img/meeting-place.2ff3fbfe.svg";